import $ from 'jquery';

// Fix for browser (e.g. IE) that does not support mix blend mode
const initPageHeaderFix = () => {
    const $headerBanner = $('.js-blend-mode');
    if (!$headerBanner.length) { return; }

    if (window.getComputedStyle(document.body).mixBlendMode === undefined) {
        $headerBanner.addClass('blend-fix');
    }
};

// doc ready
$(() => {
    initPageHeaderFix();
});



// WEBPACK FOOTER //
// ./src/sections/page-header/s-page-header.js